module.exports = require("./ia.d.ts");